var React = require('react');

function MailBillIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Path 3011","d":"M0 0h41.37v41.37H0Z","fill":"none","key":0}),React.createElement("path",{"data-name":"Path 3012","d":"m33.613 6.033-2.586-2.586-2.586 2.586-2.585-2.586-2.585 2.586-2.586-2.586-2.586 2.586-2.586-2.586-2.585 2.586-2.586-2.586-2.585 2.586-2.586-2.586v34.475l2.586-2.586 2.586 2.586 2.586-2.586 2.586 2.586 2.586-2.586 2.586 2.586 2.584-2.586 2.586 2.586 2.586-2.586 2.586 2.586 2.586-2.586 2.586 2.586V3.447Zm-.862 26.873H8.618V8.463h24.133Zm-22.409-7.05h20.685v3.447H10.342Zm0-6.895h20.685v3.447H10.342Zm0-6.895h20.685v3.447H10.342Z","fill":"#27788C","key":1})]);
}

MailBillIcon.defaultProps = {"width":"41.37","height":"41.37"};

module.exports = MailBillIcon;

MailBillIcon.default = MailBillIcon;
